import { createComponent } from '@carvana/merch-components';
import {
  ElementWithLoading,
  LoadingProps
} from '../SptPriceDetailsContent.styles';

export const Divider = createComponent('div', {
  className: 'mx-auto w-full max-w-[448px] border-b border-grey-2'
});

export const Card = createComponent<LoadingProps>(ElementWithLoading, {
  className:
    'relative mx-auto w-full max-w-[680px] rounded-md border border-grey-2 bg-white'
});

export const TradeInCard = createComponent<LoadingProps>(ElementWithLoading, {
  className:
    'relative mx-auto w-full max-w-full border-none bg-transparent m:w-[680px]'
});

export const CardContents = createComponent('div', {
  className: 'grid auto-cols-fr p-24 m:px-0 m:px-80 m:py-32'
});

export const CardHeader = createComponent('div', {
  className: 'flex flex-col gap-xl border-b border-grey-2 p-2xl text-blue-6',
  'data-qa': 'card-header'
});

export const PaymentDivider = createComponent(Divider, {
  className: 'my-16 m:my-0 m:w-auto m:border-r'
});

export const SectionDivider = createComponent(Divider, {
  className: 'my-12 m:hidden'
});

export const PriceContainer = createComponent('div', {
  className: 'flex-1 text-center font-bold text-blue-6'
});

export const Price = createComponent('p', {
  className: 'mb-8 text-blue-6 tl-header-xxl'
});

export const PriceBreakdown = createComponent('div', {
  className: 'mx-auto w-full max-w-[448px] text-blue-6 tl-body-m m:max-w-full'
});

export const LineItem = createComponent('li', {
  className: 'flex justify-between tl-body-m -:mb-8'
});

export const SummaryLineItem = createComponent('li', {
  className: 'mb-8 flex justify-between tl-header-s'
});

export const PaymentBuyDownGrid = createComponent('div', {
  className: 'grid gap-y-32 m:mb-24'
});
